import { ChessGameLite } from "../models/chess-game-lite-model";
import type { ChessGame } from "../models/chess-game-model";
import { db } from "./db";

export const ChessGameRepository = {
    async add(game: ChessGame) {
        await db.games.put(game);
    },

    async addAll(games: ChessGame[]) {
        await db.games.bulkPut(games);
    },

    async get(id: string): Promise<ChessGame | undefined> {
        return db.games.get(id);
    },

    async getBySlug(slug: string): Promise<ChessGame | undefined> {
        return db.games.where("slug").equals(slug).first();
    },

    async getAll(): Promise<ChessGame[]> {
        return db.games.toArray();
    },

    async getAllLite(): Promise<ChessGameLite[]> {
        const games = await db.games.toArray();
        return games.map(ChessGameLite.from);
    },

    async getByCollection(collectionId: string): Promise<ChessGame[]> {
        return db.games.where("collectionId").equals(collectionId).toArray();
    },

    async countByCollection(collectionId: string): Promise<number> {
        return db.games.where("collectionId").equals(collectionId).count();
    },

    async remove(id: string) {
        await db.games.delete(id);
    },

    async update(id: string, changes: Partial<ChessGame>) {
        await db.games.update(id, changes);
    },
};
